module.exports = __webpack_public_path__ + "img/btn_google_signin_light_focus_web.1c295ea4.png";